<script lang="ts" setup>
import debounce from "lodash.debounce";
import { storeToRefs } from "pinia";
import { RevisionCommentPlacementOptions } from "~/types/enums/RevisionCommentPlacement.enum";

const documentId = inject("documentId") as any;
const submittedDocumentStore = useSubmittedDocumentStore(documentId);
const { saveRevision } = submittedDocumentStore;
const { revision } = storeToRefs(submittedDocumentStore);

const onUpdate = (ev: any) => {
  const r = revision.value!;
  r.commentObject = ev;

  saveRevision(r);
};

const debounceOnUpdate = debounce(onUpdate, 1000);

const onUpdateCommentPlacement = (ev: any) => {
  const r = revision.value!;
  r.commentPlacement = ev;

  saveRevision(r);
};
</script>

<template>
  <div class="flex flex-col h-full">
    <h2 class="text-h5 mb-2">General Feedback</h2>
    <BaseSelectInput
      :options="RevisionCommentPlacementOptions"
      :model-value="
        revision?.commentPlacement ?? RevisionCommentPlacement.AfterDocument
      "
      @update:model-value="onUpdateCommentPlacement"
      :can-clear="false"
    />
    <BaseDocumentTextEditor
      class="grow min-h-0"
      :model-value="revision?.commentObject"
      @update:model-value="debounceOnUpdate"
      :show-formatting-options="true"
    ></BaseDocumentTextEditor>
  </div>
</template>

<style scoped></style>
